/* eslint-disable */
import React from 'react';
import { useContent } from '../../context/ContentContext';

const Features = () => {
  const { content, loading, features } = useContent();
  const homepageData = content?.homepage || {};
  const homeInfo = homepageData?.stats || [
    { projects: '10', pharmacists: 15}
  ];
  const displayFeatures = features && features.length > 0 ? features : [
    {
      id: 1,
      title: 'Experienced Experts',
      description: 'Our team of pharmacists and healthcare professionals has years of experience.',
      icon: 'ri-user-star-line',
      image: '/assets/img/Proper3.png'
    },
    {
      id: 2,
      title: 'Quality Services',
      description: 'We maintain the highest standards in all our products and services.',
      icon: 'ri-award-line',
      image: '/assets/img/DSC09991.jpg'
    },
    {
      id: 3,
      title: 'Custom Support',
      description: 'Personalized healthcare solutions tailored to individual needs.',
      icon: 'ri-customer-service-line',
      image: '/assets/img/DSC09933.jpg'
    },
    {
      id: 4,
      title: '24/7 Availability',
      description: 'Emergency services and support available round the clock.',
      icon: 'ri-time-line',
      image: '/assets/img/emergency.jpg'
    }
  ];

  const stats = [
    { value: homeInfo?.pharmacists+'+', label: 'Expert Pharmacists' },
    { value: homeInfo?.projects+'+', label: 'Total Projects' },
    { value: '500+', label: 'Products Available' },
    { value: '100%', label: 'Quality Assurance' }
  ];
const getImageUrl = (imageUrl) => {
  if (!imageUrl) return '/assets/img/placeholder.png';
  
  if (imageUrl.startsWith('/uploads')) {
    if (process.env.NODE_ENV === 'development') {
      return `http://localhost:5000${imageUrl}`;
    }
    const apiUrl = 'https://farmo.zuddo.biz/api';
    const backendOrigin = apiUrl.replace(/\/api\/?$/, '');
    return `${backendOrigin}${imageUrl}`;
  }

  if (imageUrl.startsWith('/assets/')) {
    return imageUrl;
  }
  
  return imageUrl;
};
  return (
    <section className="features section" id="features">
      <div className="container">
        <div className="features__header">
          <span className="section__subtitle">Features</span>
          <h2 className="section__title" style={{color: 'white'}}>Why Choose Us</h2>
          <p className="features__description">
            We provide comprehensive pharmaceutical solutions with a focus on 
            quality, reliability, and customer satisfaction.
          </p>
        </div>

        <div className="features__stats">
          <div className="stats-grid grid">
            {stats.map((stat, index) => (
              <div key={index} className="Stat-Kards">
                <h3>{stat.value}</h3>
                <p> {stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="features__grid grid">
          {displayFeatures.map(feature => (
            <div key={feature.id} className="feature-card">
              <div className="feature-card__image">
                <img src={getImageUrl(feature.img || feature.image)} alt={feature.title} />
                <div className="feature-card__icon">
                  <i className={feature.icon}></i>
                </div>
              </div>
              <div className="feature-card__content">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

    
        <div className="testimonials section">
          <h2 className="section__title" style={{color: 'white'}}>What Our Clients Say</h2>
          <div className="testimonials__grid grid">
            {[
              {
                name: 'Dr. James K.',
                role: 'Hospital Director',
                content: 'Excellent service and high-quality products. Highly recommended!',
                rating: 5
              },
              {
                name: 'Sarah M.',
                role: 'Clinic Manager',
                content: 'Reliable supplier with prompt delivery and professional support.',
                rating: 5
              },
              {
                name: 'David L.',
                role: 'Pharmacist',
                content: 'Wide range of products and knowledgeable staff. Great partnership.',
                rating: 4
              }
            ].map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                <div className="testimonial-rating">
                  {'★'.repeat(testimonial.rating)}
                  {'☆'.repeat(5 - testimonial.rating)}
                </div>
                <p className="testimonial-content">"{testimonial.content}"</p>
                <div className="testimonial-author">
                  <h4>{testimonial.name}</h4>
                  <span>{testimonial.role}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="features-cta">
          <div className="cta-content">
            <h2>Ready to Experience Quality Healthcare?</h2>
            <p>Contact us today for all your pharmaceutical needs</p>
            <div className="cta-buttons">
              <a href="/contact" className="button">Contact Us</a>
              <a href="/products" className="button button--outline">View Products</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;